// The caller owns roster eligibility and shuffling; keep its supplied order and identities.
export function groupStudents<T>(students: readonly T[], mode: "size" | "count", requested: number): T[][] {
  if (!students.length) return [];
  const value = Math.max(1, Math.round(requested));
  const count = mode === "size" ? Math.ceil(students.length / Math.max(2, value)) : Math.min(value, students.length);
  const groups = Array.from({ length: Math.max(1, count) }, () => [] as T[]);
  students.forEach((student, index) => groups[index % groups.length]!.push(student));
  return groups;
}
